<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-flex xs12>
                <v-bottom-nav :value="true" :active.sync="format" absolute color="white" class="bottom-nav elevation-1">
                    <v-btn flat color="teal" value="starters">
                        <span>Starter</span>
                    </v-btn>
                    <v-btn flat color="teal" value="dancers">
                        <span>Tänzer</span>
                    </v-btn>
                </v-bottom-nav>

                <v-expansion-panel class="mt-5" v-model="panel" :readonly="uploadingMusic">
                    <v-expansion-panel-content v-for="event in eventsWithRegistrations" :key="event.id">
                        <template slot="header">
                            <div><strong>{{ $formatDate(event.start) + ' - ' + event.name }}</strong></div>
                        </template>
                        <event-registration-list
                                :event="event"
                                :format="format"
                                :uploading.sync="uploadingMusic"
                        ></event-registration-list>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EventRegistrationList from '../../components/user/EventRegistrationList';
    import { mapState } from 'vuex';

    export default {
        components: {
            'event-registration-list': EventRegistrationList
        },
        data() {
            return {
                format: 'starters',
                panel: null,
                eventsWithRegistrations: [],
                uploadingMusic: false
            };
        },
        beforeRouteLeave (to, from, next) {
            if (!this.uploadingMusic) {
                next();
                return;
            }

            next(false);
            this.$store.commit('snackBar', {
                color: 'warning',
                text: this.$t('music_is_uploading_warning')
            });
        },
        computed: {
            ...mapState(['registrations', 'events', 'cache'])
        },
        watch: {
            panel(val) {
                if (val === null) {
                    this.$router.push('/user/event-registration-list');
                    return;
                }

                this.$router.push(`/user/event-registration-list/${this.eventsWithRegistrations[val].id}`);
                this.cache.event_registrations.last_viewed_event_id = this.eventsWithRegistrations[val].id;
            }
        },
        mounted() {
            this.eventsWithRegistrations = _.filter(this.events.items, event => {
                return _.some(this.registrations.items, registration => {
                    return registration.event_id === event.id;
                });
            }).sort(function compare(a, b) {
                let dateA = new Date(a.start);
                let dateB = new Date(b.start);
                return dateA - dateB;
            });

            if (this.$route.params.id !== undefined) {
                this.panel = _.findIndex(this.eventsWithRegistrations, e => e.id === parseInt(this.$route.params.id));
            } else if (this.eventsWithRegistrations.length == 1) {
                this.panel = 0;
            }
        }
    }
</script>

<style scoped>
    .bottom-nav {
        bottom: auto;
        top: 0;
    }
</style>
